import type { PiniaColadaOptions } from '@pinia/colada';
import { PiniaColadaRetry } from '@pinia/colada-plugin-retry';

export default {
  // Retry plugin registered globally but OFF by default (retry: 0) — queries opt in individually
  // to avoid hammering already-failing endpoints.
  plugins: [PiniaColadaRetry({ retry: 0 })],
  queryOptions: {
    staleTime: 1000 * 60,
  },
} satisfies PiniaColadaOptions;
